import { cn } from '@/lib/utils';

/**
 * The full-bleed dark eyebrow bar that introduces a section.
 *
 * Runs edge to edge in every frame — it is a divider as much as a label, which
 * is why it sits outside SectionShell's gutters.
 */
export function SectionLabel({
  children,
  className,
}: {
  children: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'bg-marketing-panel text-marketing-panel-fg mx-auto w-[calc(100%-1rem)] rounded-sm px-5 py-1.5 text-center text-sm leading-[1.3] font-semibold [letter-spacing:-0.01em] md:w-[calc(100%-2rem)]',
        className
      )}
    >
      {children}
    </div>
  );
}

/**
 * The small filled square used as a bullet, card glyph, and corner marker
 * throughout the design. Decorative everywhere it appears, so it is hidden from
 * assistive tech rather than announced as a list marker.
 */
export function MarketingSquare({
  className,
  size = 'md',
}: {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'bg-marketing-fg block shrink-0',
        size === 'sm' && 'size-2 rounded-[2px]',
        size === 'md' && 'size-2.5 rounded-[3px]',
        size === 'lg' && 'size-6 rounded-[6px]',
        className
      )}
    />
  );
}
